import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import * as FileSaver from 'file-saver';
import * as moment from 'moment';
import swal from 'sweetalert2';
import { isUndefined } from 'util';
import { environment } from '../../../environments/environment';
import { UiService } from '../ui/ui.service';
import { UserService } from '../user/user.service';

@Injectable()
export class HelperService {
  constructor(
    private router: Router,
    private user: UserService,
    private location: Location,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
    private ui: UiService
  ) {}

  get baseRoute() {
    // console.log(this.router.url);
    return ``;
  }

  static textareaToHTML(str) {
    return str.replace(/\r?\n/g, '<br />');
  }

  static pageRefreshWarning(okCallback) {
    swal({
      title: 'Are you sure?',
      text: 'Data will be lost if you leave the page.',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#9a4856',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
    }).then((value) => {
      if (value) {
        okCallback();
        // console.log(value);
      }
    });
  }
  static convertDate(date, onlyDate = false) {
    if (moment(date).isValid()) {
      return onlyDate
        ? moment(date).format('YYYY-MM-DD')
        : moment(date).format('YYYY-MM-DD HH:mm:ss');
    } else {
      return '';
    }
  }

  static titleCase(value) {
    return value
      .split(/\s+/)
      .map(
        (str) =>
          (str && str[0] && String(str[0]).toUpperCase()) +
          (str && String(str).slice(1).toLowerCase())
      )
      .join(' ');
  }

  navigateBack() {
    this.location.back();
  }

  getSafeFileUrl(file) {
    return this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file));
  }

  getDownloadablePath(file) {
    const filename = '/' + file.enc_name + '.' + file.extension;
    const filepath = file.tmp_path
      ? file.tmp_path + filename
      : file.path + filename;
    return environment.apiUrl + '/' + filepath;
  }

  fromRoman(str): number {
    if (!str) {
      return 0;
    }
    let result = 0;
    // the result is now a number, not a string
    const decimal = [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1];
    const roman = [
      'M',
      'CM',
      'D',
      'CD',
      'C',
      'XC',
      'L',
      'XL',
      'X',
      'IX',
      'V',
      'IV',
      'I',
    ];
    decimal.forEach((value, i) => {
      while (str.indexOf(roman[i]) === 0) {
        // checking for the first characters in the string
        result += value;
        // adding the decimal value to our result counter
        str = str.replace(roman[i], '');
        // remove the matched Roman letter from the beginning
      }
    });
    return result;
  }

  getProfileImageUrl(image) {
    return image
      ? environment.apiUrl + '/' + image
      : '../assets/img/icon-no-image.png';
  }

  getFromConstant(key, callback) {
    this.http.get('/bmi-others/constant/' + key).subscribe((res) => {
      callback(null, res);
    }, callback);
  }

  validateDate(date) {
    return date
      ? date instanceof Date
        ? date
        : new Date(date.replace(/-/g, '/'))
      : null;
  }

  loadListTillEnd(fetchCallback, currentPage, totalPages, endCallback = null) {
    if (currentPage >= totalPages) {
      return endCallback && endCallback();
    }
    this.ui.loader.show('helper.service.ts => loadListTillEnd');
    fetchCallback(({ currentPage, totalPages }) => {
      this.ui.loader.hide('helper.service.ts => loadListTillEnd');
      this.loadListTillEnd(fetchCallback, currentPage, totalPages, endCallback);
    });
  }

  private focusNextInputLoading = false;
  focusNextInput(
    event,
    list,
    currentPage,
    totalPages,
    loadFn,
    otherwiseFn = null
  ) {
    const targetId = event.target.id.split('-');
    if (event.keyCode === 40) {
      const nextIndex = Number(targetId.pop()) + 1;
      const nextInputId = [...targetId, nextIndex].join('-');
      if (nextIndex >= list.length) {
        if (currentPage !== totalPages) {
          this.ui.loader.show('helper.service.ts => focusNextInput');
          loadFn(() => {
            this.ui.loader.hide('helper.service.ts => focusNextInput');
            document.getElementById(nextInputId).focus();
          });
        }
      } else {
        document.getElementById(nextInputId).focus();
      }
      return;
    } else if (event.keyCode === 38) {
      const prevIndex = Number(targetId.pop()) - 1;
      const prevInputId = [...targetId, prevIndex].join('-');
      if (prevIndex >= 0) {
        document.getElementById(prevInputId).focus();
      }
      return;
    }
    if (otherwiseFn) {
      otherwiseFn();
    }
  }

  handleError(err, type) {
    if (err) {
      if (Object.keys(err).length) {
        swal(this.toTitleCase(type), err[Object.keys(err)[0]], type);
      }
    }
    return true;
  }

  toTitleCase(str: string) {
    return str[0].toUpperCase() + str.slice(1);
  }

  editFile(
    {
      file,
      defaultOrder = 0,
      noExtension = false,
      videoFile = false,
      edit = true,
    },
    callback
  ) {
    // console.log(file);
    const getValue = (id) => {
      return (<HTMLInputElement>document.getElementById(id)).value;
    };
    const name = noExtension
      ? file.name
      : file.name.split('.').slice(0, -1).join('.');
    if (videoFile) {
      console.log(!isUndefined(file.order) && !isNaN(Number(file.order)));
      file.title = file.title || name;
      file.comment = file.comment || '';
      file.order =
        !isUndefined(file.order) && !isNaN(Number(file.order))
          ? file.order
          : defaultOrder + 1;
    } else {
      file.data = {
        title: file.data ? file.data.title : name,
        comment: file.data ? file.data.comment : '',
        order:
          file.data &&
          !isUndefined(file.data.order) &&
          !isNaN(Number(file.data.order))
            ? file.data.order
            : defaultOrder + 1,
      };
    }
    const { title, comment, order } = videoFile ? file : file.data;
    swal({
      title: `${edit ? 'Edit' : 'Add'} File`,
      html: `
        <label for="edit-file-title">Name*</label>
        <input id="edit-file-title" class="swal2-input" value="${title}">
        <label for="edit-file-comment">Comment</label>
        <textarea id="edit-file-comment" class="swal2-input" style="padding:0.75em;height:100px;">${comment}</textarea>
        <label for="edit-file-order">Order</label>
        <input type="number" id="edit-file-order" class="swal2-input" style="max-width:100%;width:100%;" value="${order}">
      `,
      focusConfirm: false,
      customClass: 'edit-file',
      showCancelButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      preConfirm: () => {
        const value = {
          title: getValue('edit-file-title'),
          comment: getValue('edit-file-comment'),
          order: getValue('edit-file-order'),
        };
        return new Promise((resolve, reject) => {
          if (!value.title) {
            reject('Name field is required');
          } else {
            resolve(value);
          }
        }).catch((err) => swal.showValidationError(err));
      },
    }).then(({ value }) => {
      if (value) {
        // console.log(value);
        const arr = value.order.match(/^[0-9]{1,}/);
        if (videoFile) {
          file.title = value.title;
          file.comment = value.comment;
          file.order = arr ? Number(arr[0]) : 0;
        } else {
          file.data = {
            title: value.title,
            comment: value.comment,
            order: arr ? Number(arr[0]) : 0,
          };
        }
        callback();
      }
    });
  }

  downloadFile(file, notFromFolder = false) {
    // console.log(file);
    let pathToFile = null;
    if (notFromFolder) {
      pathToFile = file.path.startsWith('system')
        ? file.path + '/' + file.enc_name + '.' + file.extension
        : file.path.substr(file.path.indexOf('system'));
    } else {
      pathToFile = file.downloadPath || file.enc_name;
    }
    // console.log(file, notFromFolder, pathToFile);
    this.ui.loader.show();
    this.http
      .post('/download', { pathToFile }, { responseType: 'blob' })
      .subscribe(
        (res: any) => {
          this.ui.loader.hide();
          const downloadableName = file.data
            ? file.data.title + '.' + file.name.split('.').slice(-1)[0]
            : file.name;
          FileSaver.saveAs(res, downloadableName);
        },
        (err) => {
          this.ui.loader.hide();
          console.log(err);
        }
      );
  }

  confirmDelete(callback = () => {}) {
    swal({
      title: 'Are you sure?',
      text: "Click 'Yes' to delete",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#9a4856',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.value) {
        callback();
      }
    });
  }

  stripHtmlTags(html) {
    return (html && html.replace(/<\/?[^>]+(>|$)/g, '')) || '';
  }

  isHtmlEmpty(html) {
    // if (html) {
    //   for (let i = 0; i < html.length; i++) {
    //     if (html[i] === '<') {
    //       while (html[++i] !== '>' && i < html.length) { }
    //     } else {
    //       return false;
    //     }
    //   }
    // }
    return this.stripHtmlTags(html).length === 0;
  }
}



// WEBPACK FOOTER //
// G:/UTL/Teacher/Teacher-ANG/src/app/services/helper/helper.service.ts